export const AssociatedDevice = ({
  strokeColor = 'currentColor',
  width = 16,
  height = 16,
  ...props
}: {
  strokeColor?: string
  width?: number | string
  height?: number | string
}) => (
  <svg
    fill='none'
    height={height}
    viewBox='0 0 16 16'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.00033 11.3337H4.00033C3.56259 11.3337 3.12913 11.2474 2.72471 11.0799C2.3203 10.9124 1.95283 10.6669 1.6433 10.3573C1.01818 9.73223 0.666992 8.88438 0.666992 8.00033C0.666992 7.11627 1.01818 6.26842 1.6433 5.6433C2.26842 5.01818 3.11627 4.66699 4.00033 4.66699H6.00033M5.33366 8.00033H10.0003M10.0003 4.66699H12.0003C12.4381 4.66699 12.8715 4.75321 13.2759 4.92073C13.6804 5.08824 14.0478 5.33377 14.3573 5.6433C14.6669 5.95283 14.9124 6.3203 15.0799 6.72471C15.2474 7.12913 15.3337 7.56259 15.3337 8.00033C15.3337 8.43807 15.2474 8.87152 15.0799 9.27594C14.9124 9.68036 14.6669 10.0478 14.3573 10.3573C14.0478 10.6669 13.6804 10.9124 13.2759 11.0799C12.8715 11.2474 12.4381 11.3337 12.0003 11.3337H10.0003V4.66699Z'
      stroke={strokeColor}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)
